import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

new Vue({
  router,
  store,
  beforeCreate() {
    if (typeof this.$store._mutations.initialiseStore !== 'undefined') {
      this.$store.commit('initialiseStore');
    }
  },
  render: (h) => h(App),
}).$mount('#app');
